//Imports Angular
import { Pipe, PipeTransform } from "@angular/core";

const PADDING = "000000";

@Pipe({
    name: "formateoValor"
})
/**
* @class FormateoValorPipe
* @implements PipeTransform
*/
export class FormateoValorPipe implements PipeTransform {

    private DECIMAL_SEPARATOR: string;
    private THOUSANDS_SEPARATOR: string;

    /**
    * @constructor
    */
    constructor() {
        // TODO comes from configuration settings
        this.DECIMAL_SEPARATOR = ".";
        this.THOUSANDS_SEPARATOR = ",";
    }

    /**
    * @desc Function of interface for transform a value
    * @param {Number|String} value
    * @param {Number} fractionSize
    * @return {String}
    */
    public transform(value: number | string, fractionSize: number = 2): string {
        let [integer, fraction = ""] = (value || "").toString().split(this.DECIMAL_SEPARATOR);
        fraction = fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize) : "";
        integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
        return integer === '' ? '0' : integer;
    }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/recibo-pago/src/pipes/formato-valor.pipe.ts